import Vue, {VueConstructor} from 'vue'

interface Options {
    icon?: string,
    click?: () => void,
    fixed?: boolean
}

Vue.use({
        install(vue: VueConstructor) {
            vue.prototype.$msg = function(title: string, text: string, type: string = 'info', options?: Options) {
                this.$notify({
                    group: 'default',
                    type,
                    title,
                    text,
                    duration: (options && options.fixed) ? -1 : undefined,
                    data: options
                })
            }

            vue.prototype.$msgError = function(title: string, text: string, icon: string = 'error') {
                this.$msg(title, text, 'error', {icon})
            }

            vue.prototype.$msgSuccess = function(title: string, text: string, icon: string = 'check') {
                this.$msg(title, text, 'success', {icon})
            }

            vue.prototype.$msgInfo = function(title: string, text: string, icon: string) {
                this.$msg(title, text, '', {icon})
            }
        }
    }
)
